var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25971",
    "data-name": "Group 25971",
    transform: "translate(-50 -558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37482",
    "data-name": "Path 37482",
    d: "M15.5,0A15.5,15.5,0,1,1,0,15.5,15.5,15.5,0,0,1,15.5,0Z",
    transform: "translate(50 558)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25970",
    "data-name": "Group 25970",
    transform: "translate(2 257)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2441",
    "data-name": "Rectangle 2441",
    width: 17.088,
    height: 3.418,
    rx: 1,
    transform: "translate(56 321.083) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2442",
    "data-name": "Rectangle 2442",
    width: 17.088,
    height: 3.418,
    rx: 1,
    transform: "translate(58.416 309) rotate(45)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.08b1dc46f2701000243b8ac578631d54.svg";
export { ForwardRef as ReactComponent };